export default __webpack_public_path__ + "static/media/noun_Idea_1603446_cropped.6c0c0031.png";